import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faSatellite,
  faRocket,
  faHillRockslide,
} from "@fortawesome/free-solid-svg-icons"

const byType = {
  payload: faSatellite,
  "rocket body": faRocket,
  debris: faHillRockslide,
}

const Container = styled.div`
  display: flex;
  align-items: center;
`

const IconContainer = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  color: ${(props) =>
    props.type == "unknown"
      ? props.theme.colours.text.tertiary
      : props.theme.colours.rsoType[props.type] ||
        props.theme.colours.text.secondary};
`

const TextContainer = styled.div`
  font-size: 0.8rem;
  color: ${(props) => props.theme.colours.text.secondary};
  white-space: nowrap;
  margin-left: 0.5rem;
`

/**
 * Renders a resident space object type
 */
const RSOType = ({ type = "", object_type = "", printName = false }) => {
  let typ = type
    ? type.toLowerCase()
    : object_type
    ? object_type.toLowerCase()
    : ""
  // Coerce "unknown" to missing-value
  if (typ == "unknown") {
    typ = ""
  }
  const icon = byType[typ]
  return (
    <Container title={typ ? typ.toLowerCase() : "Unspecified"}>
      {icon && <IconContainer type={typ} icon={icon} />}
      {printName && <TextContainer>{typ || "-"}</TextContainer>}
    </Container>
  )
}

RSOType.propTypes = {
  type: PropTypes.string,
  object_type: PropTypes.string, // Alternative, from "Satellite"
  printName: PropTypes.bool,
}

export default RSOType
